import { gql } from '@apollo/client'
import { DocToolbar } from '@jusbrasil-web/docview/core'

import { BlogDocument } from '../../components'

export const BlogRoot = gql`
  query blogRoot($docId: NumericID!) {
    root {
      viewer: me {
        pid
        user {
          isAdmin
        }
        ...DocToolbar_viewer
      }
      document: documentByNumericID(docId: $docId, artifact: "POST_BLOG") {
        docId
        postBlogUrl
        title
        subtitle
        slug
        status
        isActive
        date
        publicationSegmentation {
          typeSegmentation
        }
        topics {
          edges {
            node {
              tid
              title
              slug
            }
          }
        }
        publisher {
          fullname
          url
          avatar: thumborAvatar {
            urlxl: thumbUrl(size: "48x48")
          }
        }

        ...BlogDocument_document
        ...DocToolbar_document
      }
    }
  }

  ${BlogDocument.fragments.document}
  ${DocToolbar.fragments.document}
  ${DocToolbar.fragments.viewer}
`
